import { Box, Typography } from "@material-ui/core";
import { Cube, Database, FilmStrip, Folder } from "phosphor-react";

import ReactApexChart from "react-apexcharts";

const StorageUsageBarChart = () => {
  const series = [
    {
      name: "Storage Used",
      data: [10, 10, 10, 25, 25], // % heights (matches 90%, 75% tops)
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 334,
      toolbar: { show: false },
      background: "transparent",
    },

    plotOptions: {
      bar: {
        columnWidth: "40%",
        distributed: true,
        borderRadius: 0,
      },
    },

    colors: [
      "#D96565", // ASHEN
      "#D9AD65", // Big Bucks Bunny
      "#65A3D9", // HOA
      "#65CDD9", // Catch
      "#6DD965", // Naruto
    ],

    dataLabels: {
      enabled: false,
    },

    xaxis: {
      categories: ["ASHEN", "Big Bucks Bunny", "HOA", "Catch", "Naruto"],
      labels: {
        style: {
          colors: "#F9F9F9",
          fontSize: "12px",
          fontFamily: "Poppins",
        },
      },
      axisBorder: {
        show: true,
        color: "#606479",
      },
      axisTicks: {
        show: true,
        color: "#606479",
      },
    },

    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        style: {
          colors: "#F9F9F9",
          fontSize: "12px",
          fontFamily: "Poppins",
        },
      },
    },

    grid: {
      borderColor: "rgba(249,249,249,0.4)",
      strokeDashArray: 6,
      xaxis: { lines: { show: false } },
    },

    tooltip: {
      theme: "dark",
      custom: ({ dataPointIndex }) => {
        const data = [
          { title: "ASHEN", seq: "5 GB", assets: "5 GB" },
          { title: "Big Bucks Bunny", seq: "5 GB", assets: "5 GB" },
          { title: "HOA", seq: "5 GB", assets: "5 GB" },
          { title: "Catch", seq: "10 GB", assets: "15 GB" },
          { title: "Naruto", seq: "10 GB", assets: "15 GB" },
        ];

        const item = data[dataPointIndex];

        return `
          <div style="
            background:#252A38;
            border:1px solid #606479;
            border-radius:4px;
            padding:8px;
            width:180px;
            font-family:Poppins;
            color:#F9F9F9;
          ">
            <div style="font-size:12px; margin-bottom:6px;">
              ${item.title}
            </div>
            <hr style="border-color:#606479" />
            <div style="font-size:12px; display:flex; justify-content:space-between;">
              <span>Sequences</span><span>${item.seq}</span>
            </div>
            <div style="font-size:12px; display:flex; justify-content:space-between;">
              <span>Assets</span><span>${item.assets}</span>
            </div>
          </div>
        `;
      },
    },

    legend: {
      show: false,
    },
  };

  return (
    <Box sx={{ width: "70%", height: "334px" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={334}
      />
    </Box>
  );
};

const STORAGE_ITEMS = [
  { label: "Sequences", size: "30 GB", icon: FilmStrip },
  { label: "Assets", size: "20 GB", icon: Cube },
  { label: "Other Media", size: "10 GB", icon: Folder },
  { label: "Miscellaneous", size: "10 GB", icon: Folder },
];

const StorageUsageCard = () => {
  const usedPercent = 70;

  return (
    <Box
      sx={{
        width: 400,
        minWidth: 300,
        maxWidth: 400,
        // height: 352,
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        borderRight: "1px solid #606479",
        paddingRight: "24px",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Database size={20} color="#F9F9F9" />
          <Typography sx={{ flexGrow: 1, fontSize: 16, color: "#F9F9F9" }}>
            Storage Usage
          </Typography>
        </Box>
        <Typography sx={{ fontSize: 16, color: "#B1B5C9" }}>
          {usedPercent}%
        </Typography>
      </Box>
      <Typography
        style={{
          fontSize: "20px",
          fontWeight: 600,
          color: "white",
        }}
      >
        INR 500
      </Typography>

      {/* Usage Info */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontSize: 18, fontWeight: 500, color: "#F9F9F9" }}>
            70 GB
          </Typography>
          <Typography sx={{ fontSize: 16, color: "#B1B5C9" }}>
            100 GB
          </Typography>
        </Box>

        {/* Progress Bar */}
        <Box
          sx={{
            width: "100%",
            height: 4,
            backgroundColor: "#606479",
            borderRadius: 20,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: `${usedPercent}%`,
              height: "100%",
              backgroundColor: "#6C65D9",
              borderRadius: "10px 0 0 10px",
            }}
          />
        </Box>
      </Box>

      {/* Breakdown List */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          pt: "10px",
        }}
      >
        {STORAGE_ITEMS.map(({ label, size, icon: Icon }) => (
          <Box
            key={label}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              px: "10px",
              py: "6px",
              backgroundColor: "#252A38",
              borderRadius: "5px",
            }}
          >
            <Icon size={18} color="#F9F9F9" />
            <Typography
              sx={{
                flexGrow: 1,
                fontSize: 14,
                color: "#F9F9F9",
              }}
            >
              {label}
            </Typography>
            <Typography sx={{ fontSize: 14, color: "#B1B5C9" }}>
              {size}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Footer */}
      <Typography
        sx={{
          mt: "auto",
          fontSize: 14,
          color: "#B1B5C9",
          textAlign: "center",
        }}
      >
        Need more storage? Upgrade your plan!
      </Typography>
    </Box>
  );
};

const MyTeamsStorageAndUsagePage = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          // width: "100%",
          display: "flex",
          // justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          color: "#888",
          border: "1px solid #606479",
          borderRadius: "10px",
          padding: "24px",
          backgroundColor: "#1B1D28",
          gap: "24px",
        }}
      >
        <Box
          sx={{
            width: 400,
            minWidth: 300,
            maxWidth: 400,
            // height: 352,
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            borderRight: "1px solid #606479",
            paddingRight: "24px",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Database size={20} color="#F9F9F9" />
              <Typography sx={{ flexGrow: 1, fontSize: 16, color: "#F9F9F9" }}>
                Storage Usage
              </Typography>
            </Box>
          </Box>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "white",
            }}
          >
            INR 500
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            paddingRight: "24px",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Database size={20} color="#F9F9F9" />
              <Typography sx={{ flexGrow: 1, fontSize: 16, color: "#F9F9F9" }}>
                Storage Usage
              </Typography>
            </Box>
          </Box>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "white",
            }}
          >
            INR 500
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          // width: "100%",
          display: "flex",
          // justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          color: "#888",
          border: "1px solid #606479",
          borderRadius: "10px",
          padding: "24px",
          backgroundColor: "#1B1D28",
          gap: "24px",
          mt: "20px",
        }}
      >
        <StorageUsageCard />
        <StorageUsageBarChart />
      </Box>
      <Box
        sx={{
          // width: "100%",
          display: "flex",
          // justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          color: "#888",
          border: "1px solid #606479",
          borderRadius: "10px",
          padding: "24px",
          backgroundColor: "#1B1D28",
          gap: "40px",
          mt: "24px",
        }}
      >
        <StorageUsageCard />
        <StorageUsageBarChart />
      </Box>
    </Box>
  );
};

export default MyTeamsStorageAndUsagePage;
